import React, { useEffect, useState } from "react";
import ListMenu from "./ListMenu/ListMenu";
import "./List.css";
import useSize from "../../../../Utils/useSize/useSize";
import Backend from "../../../../Backend/Backend";
import toast from "react-hot-toast";
import Filter from "./Filter/Filter";

import ListCard from "./ListCard";

import Loading from "../../../../Utils/Loading/Loading";
import NotFound from "../../../../Utils/NotFound/NotFound";

import moment from "moment/moment";
import * as XLSX from "xlsx";
import { saveAs } from "file-saver";

const fmt = require("indian-number-format");

const backend = await new Backend().init();

export default function MasterList() {
  const windowSize = useSize();

   const userType = Number(localStorage.getItem("user_type") || 7);

  const [loading, setLoading] = useState(false);
  const [user, setUser] = useState([]);
  const [user_search, setUser_Search] = useState([]);

  const [admin, setAdmin] = useState("");

  useEffect(() => {
    loadUser();
  }, []);

  const loadUser = () => {
    setLoading(true);
    let data = {
      server: localStorage.getItem("server"),
      id: localStorage.getItem("id"),
      username: localStorage.getItem("username"),
      token: localStorage.getItem("token"),
      admin_id: localStorage.getItem("id"),
    };

    backend.load_super(data).then((r) => {
      setLoading(false);
      if (r.error == "False") {
        setUser(r.user);
        setUser_Search(r.user);

        setAdmin(r.userdata);
      } else {
        if (r.logout == 1) {
          window.LogOut();
        } else {
          toast.error(r.message);
        }
      }
    });
  };

  const search = (a) => {
    if (a.length > 1) {
      var data = user_search.filter((x) =>
        x.username.toLowerCase().includes(a.toLowerCase())
      );
      setUser(data);
    } else {
      setUser(user_search);
    }
  };

  const downloadUserPDF = async () => {
    try {
      // 🔹 Lazy-load pdfmake safely
      const pdfMakeModule = await import("pdfmake/build/pdfmake");
      const pdfFontsModule = await import("pdfmake/build/vfs_fonts");

      const pdfMake = pdfMakeModule.default || pdfMakeModule;
      const pdfFonts = pdfFontsModule.default || pdfFontsModule;
      pdfMake.vfs = pdfFonts.pdfMake?.vfs || pdfFonts.vfs;

      const data = user;

      if (data.length === 0) {
        toast.error("No data available to export");
        return;
      }

      // 🧾 Table data
      const body = [
        [
          { text: "Username", style: "tableHeader" },
          { text: "Booked", style: "tableHeader" },
          { text: "Net-Booked", style: "tableHeader" },
          { text: "Sharing", style: "tableHeader" },
          { text: "Trade", style: "tableHeader" },
          { text: "Close Only", style: "tableHeader" },
          { text: "Status", style: "tableHeader" },
          { text: "Ip Addres", style: "tableHeader" },
          { text: "Created Date", style: "tableHeader" },
          { text: "Last Login", style: "tableHeader" },
        ],
        ...data.map((i) => [
          { text: i.username, style: "tableCell" },
          {
            text: fmt.format(i.profit_loss),
            style: "numericCell",
            color: parseFloat(i.profit_loss) > 0 ? "#399918" : "#FF0000",
          },
          {
            text: fmt.format(i.net_profit_loss),
            style: "numericCell",
            color: parseFloat(i.net_profit_loss) > 0 ? "#399918" : "#FF0000",
          },
          {
            text: i.sharing,
            style: "numericCell",
          },
          {
            text: i.trade === 1 ? "Active" : "Deactive",
            style: "numericCell",
            color: i.trade === 1 ? "#399918" : "#FF0000",
          },
          {
            text: i.only_sq === 1 ? "Active" : "Deactive",
            style: "numericCell",
            color: i.only_sq === 1 ? "#399918" : "#FF0000",
          },
          {
            text: i.status === 1 ? "Active" : "Deactive",
            style: "numericCell",
            color: i.status === 1 ? "#399918" : "#FF0000",
          },
          {
            text: i.ip ? i.ip : "-",
            style: "numericCell",
          },
          {
            text: i.date_created ? moment(i.date_created).format("DD-MM-YYYY HH:mm:ss") : "-",
            style: "numericCell",
          },
          {
            text: i.last_login_date ? moment(i.last_login_date).format("DD-MM-YYYY HH:mm:ss") : "-",
            style: "numericCell",
          },
        ]),
      ];

      // 📄 PDF structure
      const docDefinition = {
        pageSize: "A3",
        pageOrientation: "landscape",
        pageMargins: [40, 60, 40, 60],
        content: [
          {
            columns: [
              {
                image: "logo",
                width: 60,
              },
              {
                text: `${window.APP_NAME} SUPER LIST`,
                style: "header",
                width: "*",
                alignment: "right",
              },
            ],
            columnGap: 10,
          },
          {
            text: `Generated on: ${moment().format("DD-MMM-YYYY HH:mm")}`,
            style: "subHeader",
          },
          {
            text: "------------------------------------------------------------",
            margin: [0, 5, 0, 5],
          },
          {
            table: {
              headerRows: 1,
              widths: [
                "auto",
                "auto",
                "auto",
                "auto",
                "auto",
                "auto",
                "auto",
                "auto",
                "auto",
                "auto",
              ],
              body,
            },
            layout: {
              fillColor: function (rowIndex) {
                return rowIndex === 0
                  ? "#1E293B"
                  : rowIndex % 2 === 0
                  ? "#F8FAFC"
                  : null;
              },
              hLineColor: "#CBD5E1",
              vLineColor: "#CBD5E1",
            },
          },
          {
            text: `\nThank you for using ${window.APP_NAME}.`,
            style: "footerNote",
          },
        ],
        images: {
          // 🖼️ You can use a Base64 logo or URL (use online converter for your logo)
          logo: window.LOGO,
        },
        styles: {
          header: {
            fontSize: 18,
            bold: true,
            color: "#1E293B",
            margin: [0, 0, 0, 10],
          },
          subHeader: {
            fontSize: 10,
            color: "#64748B",
            margin: [0, 0, 0, 10],
          },
          tableHeader: {
            bold: true,
            fontSize: 11,
            color: "#FFFFFF",
            fillColor: "#1E293B",
            alignment: "center",
          },
          tableCell: {
            fontSize: 10,
            margin: [0, 5, 0, 5],
          },
          numericCell: {
            fontSize: 10,
            margin: [0, 5, 0, 5],
            alignment: "right",
          },
          footerNote: {
            fontSize: 9,
            color: "#475569",
            italics: true,
            margin: [0, 15, 0, 0],
            alignment: "center",
          },
        },
        footer: function (currentPage, pageCount) {
          return {
            text: `Page ${currentPage} of ${pageCount}`,
            alignment: "center",
            fontSize: 9,
            color: "#64748B",
          };
        },
      };

      // ⬇️ Download file
      pdfMake
        .createPdf(docDefinition)
        .download(`${moment().format("DD-MMM")}-Super-List.pdf`);
    } catch (err) {
      console.error("PDF generation error:", err);
      toast.error("Failed to generate PDF");
    }
  };

  const downloadExcel = () => {
    if (!user || Object.keys(user).length === 0) return;

    const data = Object.values(user).map((item) => ({
      Username: item.username,
      Booked: item.profit_loss,
      NetBooked: item.net_profit_loss,
      Sharing: item.sharing,
      Trade: item.trade === 1 ? "Active" : "Deactive",
      CloseOnly: item.only_sq === 1 ? "Active" : "Deactive",
      Status: item.status === 1 ? "Active" : "Deactive",
      Ip: item.ip,
      CreatedDate: moment(item.date_created).format("DD-MM-YYYY HH:mm:ss"),
      LastLogin: moment(item.last_login_date).format("DD-MM-YYYY HH:mm:ss"),
    }));

    const worksheet = XLSX.utils.json_to_sheet(data);
    const workbook = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(workbook, worksheet, "User");
    const excelBuffer = XLSX.write(workbook, {
      bookType: "xlsx",
      type: "array",
    });
    const blob = new Blob([excelBuffer], { type: "application/octet-stream" });
    saveAs(blob, `Super-${moment().format("DD-MMM-YYYY")}.xlsx`);
  };

  return (
    <div
      style={{
        height: windowSize[1] - 135,
        width: windowSize[0],
        display: "flex",
        flexDirection: "column",
      }}
    >
      <Filter records={user.length} search={search} downloadExcel={downloadExcel} downloadUserPDF={downloadUserPDF} />
      <ListMenu userType={userType} />

      {loading ? (
        <div className="loadingContainer">
          <Loading height={windowSize[1] - 200} />
        </div>
      ) : user.length > 0 ? (
        <div
          style={{
            height: windowSize[1] - 200,
            width: windowSize[0],
            overflowY: "scroll",
          }}
        >
          {user.map((item, index) => {
            return (
              <ListCard
                key={item.id}
                item={item}
                index={index}
                reload={loadUser}
                admin={admin}
                userType={userType}
              />
            );
          })}
        </div>
      ) : (
        <NotFound height={windowSize[1] - 200} title={"Nothing here"} subtext={"No User Summary Found."} />
      )}
    </div>
  );
}
